import React, { Component } from "react";
import { Card, Button } from "react-bootstrap";
import { ReactFlowProvider } from "@xyflow/react";
import { GoPlus } from 'react-icons/go';
import FlowWrapper from "./wrapper.js";
import ControlsPane from "./controls/index.js";
import "./editor.css";

export default class EditorPane extends Component {
  render() {
    // Disable editing entirely if
    // - revision is not editable
    // - global operation is in progress
    const disabled = !this.props.shell.shellInterface.canEditRevision() || this.props.shell.progress;

    return (
      <>
        <Card>
          <Card.Body>
            <div className="workflow-controls-pane-left">
              {!this.props.shell.library.visible &&
                <Button variant="light" onClick={() => {
                  this.props.shell.shellInterface.updatePane("library", true);
                }}><GoPlus/></Button>
              }
            </div>

            <ControlsPane
              shell={this.props.shell}
            />

            <div className="workflow-editor workflow-editor-surface" ref={this.props.surfaceRef}>
              <ReactFlowProvider>
                <FlowWrapper
                  shell={this.props.shell}
                  shown={this.props.shown}
                  onInit={this.props.onReactFlowInit}
                  edgesUpdatable={!disabled}
                  edgesFocusable={!disabled}
                  nodesDraggable={!disabled}
                  nodesConnectable={!disabled}
                  nodesFocusable={!disabled}
                  zoomOnDoubleClick={!disabled}
                />
              </ReactFlowProvider>
            </div>
          </Card.Body>
        </Card>
      </>
    );
  }
}
